import Base from '../../base';

export default class Default extends Base {
  init() {
    this.bus.$on('vue/loaded', (d) => {this.imageRefs(d);});
  }

  imageRefs(d) {
    var refs = this.b.vm.$refs;

    //Map refs to state
    this.s.header.images = _
      .chain(refs)
      .map((r,k) => {
        return {
          key: k,
          $el: $(r),
          $a: $(r).closest('a'),
          a: $(r).closest('a')[0],
          el: r,
          x: -9999,
          y:-9999,
          active: false
        }
      })
      .filter((r) => {
        return r.key.indexOf('headerImage') > -1
      })
      .value();
  }
}